import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import type { GrayFactBoxProps } from "./GrayFactBox.d";

export const GrayFactBoxPart = (props: ComponentProps<PartData>) => {
  const { container, content } = (props.data as GrayFactBoxProps) ?? {};

  return (
    <footer className="bg-grey-50">
      <div
        className={`${container}  article-body`}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </footer>
  );
};

export default GrayFactBoxPart;
